import { render } from "./NotpbSchoolRelevancy.vue?vue&type=template&id=404fc3ad&scoped=true"
import script from "./NotpbSchoolRelevancy.vue?vue&type=script&lang=js"
export * from "./NotpbSchoolRelevancy.vue?vue&type=script&lang=js"

import "./NotpbSchoolRelevancy.vue?vue&type=style&index=0&id=404fc3ad&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404fc3ad"]])

export default __exports__